import React from 'react';
import ReactDOM from 'react-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/global.css';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/hoc/ErrorBoundary';
import { RecoilRoot } from "recoil";


ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <RecoilRoot>
      <App />
      </RecoilRoot>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
